<div class="padded-side-nav page-container">
  <!-- TODO: Fix this error -->
  <!-- <tools-multi-nav-category-select [navItems]="list"></tools-multi-nav-category-select> -->
  <div class="header">
    @if (dbFetchError === true && deviceFetchError === true) {
    <div class="error-container">
      <p>Unable To Connect To Device: Failed To Load Details . . .</p>
    </div>
    }@else if (displayHeader === false) {
      <div class="centered-content">
        <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
      </div>
    } @else {
    <huge-monorepo-header [config]="headerData"></huge-monorepo-header>
    }
  </div>
  @if (displayHeader) {
    <app-navigation-tab #navBar [fireInitialEvent]="false" class="nav-bar" [tabConfig]="tabConfig" [loading]="navLoading"
      (onTabChanged)="changeTab($event.tab.title)" [selectedTabIndex]="preselectedTab"
      [selectedViewIndex]="preselectedTab">
    </app-navigation-tab>
  }
  <div class="inner-content">
    @switch (currentTab) {
    @case ("General") {
    <huge-monorepo-teltonika-device-general></huge-monorepo-teltonika-device-general>
    }
    @case ("Remote Access") {
    <huge-monorepo-teltonika-device-remote-access></huge-monorepo-teltonika-device-remote-access>
    }
    @case ("Metrics") {
    <huge-monorepo-teltonika-device-metrics></huge-monorepo-teltonika-device-metrics>
    }
    @case ("Data Usage") {
    <huge-monorepo-teltonika-device-data-usage></huge-monorepo-teltonika-device-data-usage>
    }
    @case ("Location") {
    <huge-monorepo-teltonika-device-location></huge-monorepo-teltonika-device-location>
    }
    @case ("Ports") {
    <huge-monorepo-teltonika-device-ports></huge-monorepo-teltonika-device-ports>
    }
    @case ("Troubleshooting") {
    <huge-monorepo-teltonika-device-trouble-shooting></huge-monorepo-teltonika-device-trouble-shooting>
    }
    @case("Auditing") {
    <huge-monorepo-teltonika-device-auditing></huge-monorepo-teltonika-device-auditing>
    }
    <!-- @case ("Monitoring") {
    <huge-monorepo-teltonika-device-monitoring></huge-monorepo-teltonika-device-monitoring>
    } -->
    @case ("Reporting") {
    <huge-monorepo-teltonika-device-reporting [wanSchedulingEnabled]="wanSchedulerEnabled"></huge-monorepo-teltonika-device-reporting>
    }
    @case ("Other Services") {
    <huge-monorepo-teltonika-device-other-services></huge-monorepo-teltonika-device-other-services>
    }
    }
  </div>
</div>
